import { Injectable } from '@angular/core';
import { Config } from './config';
import { IConfig } from './i-config';

let baseConfig: IConfig;

export const configLoader = new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest();
  const method = 'GET';
  const url = '/config';

  xhr.open(method, url, true);

  xhr.onload = () => {
    if (xhr.status === 200) {
      baseConfig = JSON.parse(xhr.responseText);
      resolve();
    } else {
      reject(new Error('Could not load config'));
    }
  };

  xhr.send();
});

@Injectable({ providedIn: 'root' })
export class ServerConfigService {
  get config(): Config {
    return new Config(baseConfig);
  }
}
